module.exports = __webpack_public_path__ + "img/qianxuening.6fa53501.jpg";